class YonkaGWP extends HTMLElement {
    constructor() {
        super();

        this.buttons = this.querySelectorAll('button')
        this.pointsCheckbox = this.querySelector('input[name="add_points"]')
        this.cartElement = document.querySelector('ajax-cart')

        if(this.buttons.length > 0) {
            const __self = this;
            this.buttons.forEach((btn)=>{
                btn.addEventListener('click',function(){
                    const variantId = this.dataset.variantId
                    const gwpLabel = this.dataset.gwpLabel
                    const gwpHandle = this.dataset.gwpHandle
                    const hash = this.dataset.hash
                    const time = new Date().getTime()
                    const gwpKey = time + parseFloat(hash)
                    const body = JSON.stringify({
                        items: [
                            {
                                id: variantId,
                                quantity: 1,
                                properties: {
                                    '__gwp': true,
                                    '__gwp_handle': gwpHandle,
                                    '__gwp_key': gwpKey.toFixed(2),
                                    '__timestamp': time,
                                    'GWP': gwpLabel
                                }
                            }
                        ]
                    });
                    __self.classList.add('loading');
                    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
                        .then((response) => response.json())
                        .then(() => {
                            if(document.querySelector('#PopupModal-quickshop')){
                                document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
                            }

                            __self.classList.remove('loading');
                            __self.cartElement.getCartData('open_drawer');
                        })
                        .catch((e) => {
                            console.error(e);
                            __self.classList.remove('loading');
                        })
                        .finally(() => {
                            __self.classList.remove('loading');
                        });
                })
            })
        }

        if(this.pointsCheckbox) {
            this.pointsCheckbox.addEventListener('change',()=>{
                console.log('CH');
                const variantId = this.pointsCheckbox.dataset.variantId
                const gwpPointsAmount = this.pointsCheckbox.dataset.gwpPointsAmount
                const gwpPointsLabel = this.pointsCheckbox.dataset.gwpPointsLabel
                const gwpHandle = this.dataset.gwpHandle
                const hash = this.dataset.hash
                const __self = this;
                const time = new Date().getTime();
                const gwpKey = time + parseFloat(hash);
                const body = JSON.stringify({
                    items: [
                        {
                            id: variantId,
                            quantity: 1,
                            properties: {
                                '__gwp': true,
                                '__gwp_points': gwpPointsAmount,
                                '__gwp_key': gwpKey.toFixed(2),
                                '__timestamp': time,
                                '__gwp_handle': gwpHandle,
                                'GWP': gwpPointsLabel
                            }
                        }
                    ]
                });
                __self.classList.add('loading');
                fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
                .then((response) => response.json())
                .then(() => {
                    if(document.querySelector('#PopupModal-quickshop')){
                        document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
                    }

                    __self.classList.remove('loading');
                    __self.cartElement.getCartData('open_drawer');
                })
                .catch((e) => {
                    console.error(e);
                    __self.classList.remove('loading');
                })
                .finally(() => {
                    __self.classList.remove('loading');
                });
            })
        }

        if(this.dataset.removeGwp == 'true') {
          const __self = this;
          const body = JSON.stringify({
            id: this.dataset.activeId,
            quantity: 0
          });
          __self.classList.add('loading');
          fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then(() => {
              if(document.querySelector('#PopupModal-quickshop')){
                  document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
              }
      
              __self.classList.remove('loading');
              __self.cartElement.getCartData('open_drawer');
          })
          .catch((e) => {
              console.error(e);
              __self.classList.remove('loading');
          })
          .finally(() => {
              __self.classList.remove('loading');
          });
        }
    }
}
customElements.define("yonka-gwp", YonkaGWP);
